<template>
    <Teleport to="body">
        <Transition name="sheet">
            <div
                v-if="modelValue"
                class="bottom-sheet-wrapper"
                @click.self="$emit('update:modelValue', false)"
            >
                <div class="bottom-sheet">
                    <div
                        class="bottom-sheet-handle"
                        @click="$emit('update:modelValue', false)"
                    >
                        <div class="handle-bar"></div>
                    </div>
                    <div class="bottom-sheet-content">
                        <slot />
                    </div>
                </div>
            </div>
        </Transition>
    </Teleport>
</template>

<script>
export default {
    name: 'BottomSheet',
    props: {
        modelValue: {
            type: Boolean,
            required: true,
        },
    },
    emits: ['update:modelValue'],
    watch: {
        modelValue(open) {
            document.body.style.overflow = open ? 'hidden' : '';
        },
    },
    beforeUnmount() {
        document.body.style.overflow = '';
    },
};
</script>

<style scoped>
.bottom-sheet-wrapper {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 50;
    display: flex;
    align-items: flex-end;
}

.bottom-sheet {
    width: 100%;
    max-height: 85vh;
    background: oklch(var(--b1));
    border-radius: 1.25rem 1.25rem 0 0;
    display: flex;
    flex-direction: column;
}

.bottom-sheet-handle {
    padding: 0.75rem;
    display: flex;
    justify-content: center;
    cursor: pointer;
    flex-shrink: 0;
}

.handle-bar {
    width: 2.5rem;
    height: 0.25rem;
    border-radius: 9999px;
    background: oklch(var(--bc) / 0.2);
}

.bottom-sheet-content {
    overflow-y: auto;
    padding: 0 1.25rem 1.25rem;
    flex: 1;
}

.sheet-enter-active,
.sheet-leave-active {
    transition: opacity 0.2s ease;
}

.sheet-enter-active .bottom-sheet,
.sheet-leave-active .bottom-sheet {
    transition: transform 0.25s ease;
}

.sheet-enter-from,
.sheet-leave-to {
    opacity: 0;
}

.sheet-enter-from .bottom-sheet,
.sheet-leave-to .bottom-sheet {
    transform: translateY(100%);
}
</style>
